import React from 'react';
import { Card } from "react-bootstrap";
import face_Bence_Lestyan from "../../assets/img/face_bence_lestyan.jpeg";
import ShowMoreText from "react-show-more-text";
import proj_dataviz_for_diag_purposes from "../../assets/img/proj_dataviz_for_diag_purposes.png";

const Bence_Lestyan_dataviz = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_dataviz_for_diag_purposes} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_Bence_Lestyan}
              /* ez a szöveg lesz majd a banneren */
              alt="Investigation of data visualization methods for diagnostic purposes in computer vision"
            />{" "}
            <p className="text7">Bence Lestyan</p>
            <br />
            <p className="text8">
              ML Developer{" "}
            </p>
            <p className="text8">Asura Technologies </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            After some point, the performance of trained models in computer vision is 
            challenging to improve. In most cases, the breakthrough can be reached by 
            better understanding the model's behavior and leveraging this knowledge at 
            some point in the training process. The aim of the visualization is two-folded; 
            at first, the student has to investigate methods that show the shortcomings 
            of object detection models, such as box sizes, aspect ratios, and locations 
            that could be learned better during the training process. Find the relation 
            between the False Positive and False Negative objects and use them to improve 
            the training dataset. The second aspect is to investigate methods that can 
            shed light on the hidden associative relations between the decision-making 
            of the trained network, such as saliency maps.
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Bence_Lestyan_dataviz;